// bootstrap italia version variable
// useful to check for the current version
// eslint-disable-next-line no-unused-vars
const BOOTSTRAP_ITALIA_VERSION = '2.7.10'
export default BOOTSTRAP_ITALIA_VERSION
